import { addDatapointConfig } from 'owa-analytics-actions';
import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/lightRPStore';
import { saveIsLightRPOnToStorage } from '../utils/localStorage';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';

const toggleLightRPMutator: () => void = mutatorAction('toggleLightRPState', (): void => {
    const lightRPStore = getStore();
    // User-initiated UI toggle event: User toggled light reading pane on/off
    const mailboxInfo = getModuleContextMailboxInfo();

    lightRPStore.isLightRPOn
        ? addDatapointConfig('ToggleLightRPOff', mailboxInfo, undefined, {
              isLightRPOn: !lightRPStore.isLightRPOn,
          })
        : addDatapointConfig('ToggleLightRPOn', mailboxInfo, undefined, {
              isLightRPOn: !lightRPStore.isLightRPOn,
          });

    lightRPStore.isLightRPOn = !lightRPStore.isLightRPOn;
    saveIsLightRPOnToStorage(lightRPStore.isLightRPOn);
});
export default toggleLightRPMutator;
